site.hero = {
	init:function() {
		if ($('#hero li').length > 1) {
			site.owl.init('#hero > ul', {
				loop: true,
				dots: true,
				nav: false,
				items: 1,
				navText: ["", ""],
				smartSpeed:600
			});
		}
	}
};

site.inits.push('site.hero.init()');
